import { useState } from 'react';

export default function ArticleContent() {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Tổng quan', icon: 'ri-file-list-3-line' },
    { id: 'requirements', label: 'Hồ sơ cần thiết', icon: 'ri-file-text-line' },
    { id: 'interview', label: 'Phỏng vấn', icon: 'ri-question-answer-line' },
    { id: 'tips', label: 'Mẹo từ chuyên gia', icon: 'ri-lightbulb-line' }
  ];

  return (
    <article className="bg-white">
      {/* Article Header */}
      <header className="mb-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="bg-teal-100 text-teal-700 text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">
            Hướng dẫn chi tiết
          </span>
          <span className="text-sm text-gray-500">Cập nhật: 15/01/2025</span>
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
          Hướng dẫn toàn diện xin Visa du lịch Mỹ (B1/B2): Kinh nghiệm từ chuyên gia 15 năm
        </h1>
        
        <div className="flex items-center gap-4 mb-6">
          <div className="flex items-center gap-2">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-500 to-blue-600 flex items-center justify-center text-white font-bold">
              TH
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">Trần Hải - Chuyên gia Visa</p>
              <p className="text-xs text-gray-500">15 năm kinh nghiệm tư vấn visa Mỹ</p>
            </div>
          </div>
        </div>

        <div className="w-full h-96 rounded-xl overflow-hidden mb-6">
          <img
            src="https://public.readdy.ai/ai/img_res/5386bc28b6f58c11af347047df931f24.jpg"
            alt="Visa Mỹ"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg">
          <p className="text-base leading-relaxed text-gray-700">
            <strong className="text-blue-900">Sau 15 năm làm việc trong lĩnh vực tư vấn visa Mỹ</strong>, tôi đã giúp hơn 3,000 khách hàng thành công trong việc xin visa du lịch Mỹ. Trong bài viết này, tôi sẽ chia sẻ toàn bộ kinh nghiệm, từ chuẩn bị hồ sơ đến vượt qua phỏng vấn tại Đại sứ quán, giúp bạn tối đa hóa cơ hội được cấp visa.
          </p>
        </div>
      </header>

      {/* Tab Navigation */}
      <div className="mb-8">
        <div className="grid grid-cols-2 gap-3">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-3 px-6 py-4 text-sm font-medium transition-all cursor-pointer rounded-lg border-2 ${
                activeTab === tab.id
                  ? 'bg-teal-600 text-white border-teal-600 shadow-lg'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-teal-300 hover:text-teal-600'
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              <span className="font-semibold">{tab.label}</span>
              {activeTab === tab.id && (
                <i className="ri-check-line text-xl ml-auto"></i>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="prose prose-lg max-w-none">
        {activeTab === 'overview' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Tổng quan về Visa du lịch Mỹ (B1/B2)</h2>
            
            <div className="bg-gradient-to-r from-orange-50 to-yellow-50 border border-orange-200 rounded-xl p-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-4xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Visa B1/B2 là gì?</h3>
                  <p className="text-sm text-gray-700 leading-relaxed mb-0">
                    Visa B1/B2 là loại visa phi định cư cho phép công dân nước ngoài nhập cảnh vào Hoa Kỳ trong thời gian ngắn với mục đích du lịch, thăm thân, điều trị y tế hoặc tham gia các hoạt động kinh doanh không sinh lợi. Thời hạn visa thường là 10 năm với mỗi lần lưu trú tối đa 6 tháng.
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Các loại Visa B1/B2</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 border-blue-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-briefcase-line text-4xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3">Visa B1 - Công tác</h4>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Tham dự hội nghị, hội thảo</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Đàm phán hợp đồng kinh doanh</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Tham gia triển lãm thương mại</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Gặp gỡ đối tác kinh doanh</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white border-2 border-teal-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-plane-line text-4xl text-teal-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3">Visa B2 - Du lịch</h4>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-teal-600 mt-1"></i>
                    <span>Du lịch, nghỉ dưỡng</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-teal-600 mt-1"></i>
                    <span>Thăm thân nhân, bạn bè</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-teal-600 mt-1"></i>
                    <span>Điều trị y tế</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-teal-600 mt-1"></i>
                    <span>Tham gia sự kiện xã hội</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* CTA Box */}
            <div className="bg-gradient-to-br from-teal-600 to-blue-700 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">Khám phá các Tour Mỹ hấp dẫn</h3>
                  <p className="text-sm text-white/90">
                    Xem ngay các gói tour du lịch Mỹ được thiết kế chuyên nghiệp, phù hợp với visa B1/B2 của bạn
                  </p>
                </div>
                <button className="bg-white text-teal-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  Xem Tour Mỹ →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Quy trình xin Visa tổng quan</h3>
            
            <div className="space-y-4 mb-8">
              {[
                { step: 1, title: 'Điền đơn DS-160', time: '45-60 phút', desc: 'Hoàn thành mẫu đơn trực tuyến với thông tin chính xác' },
                { step: 2, title: 'Thanh toán lệ phí', time: '5 phút', desc: 'Phí visa hiện tại: $185 (khoảng 4.6 triệu VNĐ)' },
                { step: 3, title: 'Đặt lịch phỏng vấn', time: '10 phút', desc: 'Chọn ngày giờ phù hợp tại Đại sứ quán/Lãnh sự quán' },
                { step: 4, title: 'Chuẩn bị hồ sơ', time: '3-5 ngày', desc: 'Thu thập và sắp xếp đầy đủ giấy tờ cần thiết' },
                { step: 5, title: 'Phỏng vấn', time: '3-5 phút', desc: 'Trả lời câu hỏi của l영s viên một cách tự tin' },
                { step: 6, title: 'Nhận kết quả', time: '5-7 ngày', desc: 'Nhận hộ chiếu có visa qua dịch vụ chuyển phát' }
              ].map((item) => (
                <div key={item.step} className="flex gap-4 items-start bg-gray-50 rounded-lg p-5 hover:bg-gray-100 transition-colors">
                  <div className="w-10 h-10 rounded-full bg-teal-600 text-white flex items-center justify-center font-bold flex-shrink-0">
                    {item.step}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                      <h4 className="text-base font-bold text-gray-900">{item.title}</h4>
                      <span className="text-xs text-gray-500 bg-white px-3 py-1 rounded-full whitespace-nowrap">{item.time}</span>
                    </div>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg">
              <div className="flex items-start gap-3">
                <i className="ri-error-warning-line text-2xl text-red-600 mt-1"></i>
                <div>
                  <h4 className="text-base font-bold text-red-900 mb-2">Lưu ý quan trọng</h4>
                  <p className="text-sm text-gray-700 mb-0">
                    Thời gian chờ đợi lịch phỏng vấn có thể từ 2-8 tuần tùy theo mùa. Nên đặt lịch sớm ít nhất 3 tháng trước ngày dự kiến đi. Mùa cao điểm (tháng 5-8) thường có thời gian chờ lâu hơn.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'requirements' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Hồ sơ cần thiết cho Visa B1/B2</h2>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-file-list-3-line text-3xl text-yellow-600"></i>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Checklist đầy đủ</h3>
                  <p className="text-sm text-gray-700 mb-0">
                    Dưới đây là danh sách đầy đủ các giấy tờ bạn cần chuẩn bị. Hồ sơ càng đầy đủ và rõ ràng, cơ hội được duyệt visa càng cao.
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">1. Giấy tờ bắt buộc</h3>
            
            <div className="space-y-4 mb-8">
              {[
                {
                  title: 'Hộ chiếu',
                  icon: 'ri-passport-line',
                  color: 'blue',
                  items: [
                    'Còn hạn ít nhất 6 tháng kể từ ngày dự kiến nhập cảnh Mỹ',
                    'Có ít nhất 2 trang trống để đóng dấu visa',
                    'Nếu có hộ chiếu cũ, mang theo để chứng minh lịch sử xuất nhập cảnh'
                  ]
                },
                {
                  title: 'Ảnh 5x5cm',
                  icon: 'ri-camera-line',
                  color: 'teal',
                  items: [
                    'Chụp trong vòng 6 tháng gần đây',
                    'Nền trắng, không đeo kính, không cười',
                    'Kích thước 5x5cm (2x2 inch)',
                    'Định dạng file JPEG nếu upload online'
                  ]
                },
                {
                  title: 'Xác nhận DS-160',
                  icon: 'ri-file-text-line',
                  color: 'orange',
                  items: [
                    'In trang xác nhận có mã barcode',
                    'Kiểm tra kỹ thông tin trước khi submit',
                    'Lưu lại Application ID để tra cứu'
                  ]
                },
                {
                  title: 'Biên lai phỏng vấn',
                  icon: 'ri-calendar-check-line',
                  color: 'green',
                  items: [
                    'In email xác nhận lịch hẹn',
                    'Đến đúng giờ, sớm hơn 15 phút',
                    'Mang theo giấy tờ tùy thân có ảnh'
                  ]
                }
              ].map((doc, index) => (
                <div key={index} className="border-2 border-gray-200 rounded-xl p-6 hover:border-teal-300 transition-colors">
                  <div className="flex items-start gap-4">
                    <div className={`w-12 h-12 flex items-center justify-center flex-shrink-0 bg-${doc.color}-100 rounded-lg`}>
                      <i className={`${doc.icon} text-3xl text-${doc.color}-600`}></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-gray-900 mb-3">{doc.title}</h4>
                      <ul className="space-y-2">
                        {doc.items.map((item, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                            <i className={`ri-checkbox-circle-line text-${doc.color}-600 mt-0.5`}></i>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">2. Giấy tờ chứng minh tài chính</h3>
            
            <div className="bg-white border-2 border-green-200 rounded-xl p-6 mb-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-bank-line text-green-600"></i>
                    Chứng minh thu nhập
                  </h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-green-600 mt-0.5"></i>
                      <span>Sao kê ngân hàng 6 tháng gần nhất</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-green-600 mt-0.5"></i>
                      <span>Giấy xác nhận lương từ công ty</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-green-600 mt-0.5"></i>
                      <span>Hợp đồng lao động</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-green-600 mt-0.5"></i>
                      <span>Quyết định bổ nhiệm (nếu có)</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-home-line text-green-600"></i>
                    Chứng minh tài sản
                  </h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-green-600 mt-0.5"></i>
                      <span>Sổ đỏ nhà đất (bản sao công chứng)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-green-600 mt-0.5"></i>
                      <span>Giấy đăng ký xe ô tô</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-green-600 mt-0.5"></i>
                      <span>Giấy phép kinh doanh (nếu có)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-green-600 mt-0.5"></i>
                      <span>Chứng chỉ cổ phiếu, trái phiếu</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-600 to-teal-600 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">Đã có Visa? Đặt Tour ngay!</h3>
                  <p className="text-sm text-white/90">
                    Khám phá các gói tour Mỹ từ Đông sang Tây, từ Bắc xuống Nam với giá tốt nhất
                  </p>
                </div>
                <button className="bg-white text-blue-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  Khám phá Tour →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">3. Giấy tờ bổ sung (tùy trường hợp)</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {[
                { title: 'Nếu đi du lịch', items: ['Lịch trình chi tiết', 'Booking khách sạn', 'Vé máy bay khứ hồi'] },
                { title: 'Nếu thăm thân', items: ['Thư mời từ người thân', 'Bằng chứng quan hệ', 'Giấy tờ của người bảo lãnh'] },
                { title: 'Nếu đi công tác', items: ['Thư mời từ công ty Mỹ', 'Giấy giới thiệu công ty VN', 'Hợp đồng/thỏa thuận'] },
                { title: 'Nếu đi điều trị', items: ['Thư từ bệnh viện Mỹ', 'Hồ sơ bệnh án', 'Chứng minh khả năng chi trả'] }
              ].map((category, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-5 border border-gray-200">
                  <h4 className="text-base font-bold text-gray-900 mb-3">{category.title}</h4>
                  <ul className="space-y-2">
                    {category.items.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                        <i className="ri-check-line text-teal-600 mt-0.5"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-blue-900 mb-2">💡 Mẹo từ chuyên gia</h4>
              <p className="text-sm text-gray-700 mb-0">
                Hồ sơ tài chính là yếu tố quan trọng nhất. Số dư tài khoản nên ít nhất 150-200 triệu VNĐ cho một người. Nếu đi nhóm, mỗi người nên có ít nhất 100 triệu VNĐ. Quan trọng là phải chứng minh được nguồn gốc thu nhập hợp pháp và ổn định.
              </p>
            </div>
          </div>
        )}

        {activeTab === 'interview' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Hướng dẫn vượt qua phỏng vấn Visa</h2>
            
            <div className="w-full h-80 rounded-xl overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20US%20embassy%20visa%20interview%20scene%20with%20consular%20officer%20at%20window%20counter%2C%20applicant%20presenting%20documents%2C%20official%20government%20office%20interior%20with%20American%20flag%2C%20bright%20professional%20lighting%2C%20clean%20modern%20embassy%20environment&width=1200&height=500&seq=interview-scene&orientation=landscape"
                alt="Phỏng vấn visa"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="bg-orange-50 border border-orange-200 rounded-xl p-6 mb-8">
              <h3 className="text-lg font-bold text-gray-900 mb-3">Buổi phỏng vấn diễn ra như thế nào?</h3>
              <p className="text-sm text-gray-700 mb-4">
                Buổi phỏng vấn thường chỉ kéo dài 3-5 phút. Lãnh sự viên sẽ đặt câu hỏi bằng tiếng Anh hoặc tiếng Việt để đánh giá mục đích chuyến đi, khả năng tài chính và ý định quay về Việt Nam của bạn.
              </p>
              <div className="flex items-center gap-2 text-sm text-orange-700 bg-orange-100 px-4 py-2 rounded-lg">
                <i className="ri-time-line text-lg"></i>
                <span className="font-semibold">Thời gian trung bình: 3-5 phút</span>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Các câu hỏi thường gặp và cách trả lời</h3>
            
            <div className="space-y-4 mb-8">
              {[
                {
                  question: 'Mục đích chuyến đi của bạn là gì?',
                  answer: 'Trả lời ngắn gọn, rõ ràng: "Tôi đi du lịch/thăm thân/công tác tại [địa điểm] trong [thời gian]"',
                  tips: 'Không nói quá dài dòng, tập trung vào mục đích chính'
                },
                {
                  question: 'Bạn làm nghề gì? Thu nhập bao nhiêu?',
                  answer: 'Nêu rõ chức vụ, công ty và mức lương: "Tôi là [chức vụ] tại [công ty], thu nhập [số tiền]/tháng"',
                  tips: 'Chuẩn bị sẵn giấy xác nhận lương để xuất trình nếu cần'
                },
                {
                  question: 'Ai tài trợ cho chuyến đi?',
                  answer: 'Nếu tự tài trợ: "Tôi tự chi trả từ thu nhập công việc". Nếu có người tài trợ: "Gia đình/công ty tài trợ"',
                  tips: 'Phải có bằng chứng tài chính rõ ràng'
                },
                {
                  question: 'Bạn đã đi nước ngoài bao giờ chưa?',
                  answer: 'Liệt kê các nước đã đi, đặc biệt là các nước phát triển: "Tôi đã đi [danh sách quốc gia]"',
                  tips: 'Lịch sử xuất nhập cảnh tốt là điểm cộng lớn'
                },
                {
                  question: 'Tại sao bạn chắc chắn sẽ quay về Việt Nam?',
                  answer: 'Nhấn mạnh ràng buộc: "Tôi có công việc ổn định, gia đình và tài sản tại Việt Nam"',
                  tips: 'Đây là câu hỏi quan trọng nhất, cần trả lời thuyết phục'
                },
                {
                  question: 'Bạn có người thân ở Mỹ không?',
                  answer: 'Trả lời trung thực. Nếu có: "Có, [quan hệ] đang sống tại [địa điểm]"',
                  tips: 'Không nên nói dối, Đại sứ quán có thể kiểm tra'
                }
              ].map((qa, index) => (
                <div key={index} className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-teal-300 transition-colors">
                  <div className="flex items-start gap-3 mb-3">
                    <div className="w-8 h-8 rounded-full bg-teal-100 text-teal-700 flex items-center justify-center font-bold flex-shrink-0 text-sm">
                      Q{index + 1}
                    </div>
                    <h4 className="text-base font-bold text-gray-900 flex-1">{qa.question}</h4>
                  </div>
                  <div className="ml-11">
                    <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg mb-3">
                      <p className="text-sm text-gray-700 mb-0">
                        <strong className="text-green-900">Trả lời mẫu:</strong> {qa.answer}
                      </p>
                    </div>
                    <div className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-lightbulb-line text-yellow-600 mt-0.5"></i>
                      <span><strong>Mẹo:</strong> {qa.tips}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Những điều NÊN và KHÔNG NÊN làm</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-green-50 border-2 border-green-300 rounded-xl p-6">
                <h4 className="text-lg font-bold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-2xl"></i>
                  NÊN làm
                </h4>
                <ul className="space-y-3">
                  {[
                    'Ăn mặc lịch sự, chỉnh chu',
                    'Đến sớm 15-30 phút',
                    'Trả lời ngắn gọn, tự tin',
                    'Nhìn thẳng vào mắt lãnh sự',
                    'Mang theo đầy đủ giấy tờ',
                    'Giữ thái độ lịch sự, tôn trọng',
                    'Nói thật về mục đích chuyến đi'
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-green-600 text-lg mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-red-50 border-2 border-red-300 rounded-xl p-6">
                <h4 className="text-lg font-bold text-red-900 mb-4 flex items-center gap-2">
                  <i className="ri-close-circle-line text-2xl"></i>
                  KHÔNG NÊN làm
                </h4>
                <ul className="space-y-3">
                  {[
                    'Nói dối hoặc cung cấp thông tin sai',
                    'Ăn mặc quá xuề xòa hoặc hở hang',
                    'Tranh cãi với lãnh sự viên',
                    'Nói quá nhiều, lan man',
                    'Tỏ ra lo lắng, căng thẳng quá mức',
                    'Mang theo điện thoại vào phòng phỏng vấn',
                    'Đưa hối lộ hoặc có hành vi không đúng mực'
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-close-line text-red-600 text-lg mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">Chuẩn bị sẵn lịch trình du lịch</h3>
                  <p className="text-sm text-white/90">
                    Có lịch trình cụ thể sẽ giúp bạn tự tin hơn khi phỏng vấn. Xem ngay các tour Mỹ được thiết kế chuyên nghiệp
                  </p>
                </div>
                <button className="bg-white text-purple-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  Xem lịch trình Tour →
                </button>
              </div>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-blue-900 mb-2">💡 Bí quyết vàng từ chuyên gia</h4>
              <p className="text-sm text-gray-700 mb-0">
                Sau 15 năm kinh nghiệm, tôi nhận thấy yếu tố quan trọng nhất là <strong>sự chân thành và tự tin</strong>. Lãnh sự viên được đào tạo để phát hiện sự không trung thực. Hãy chuẩn bị kỹ càng, nhưng đừng học thuộc lòng câu trả lời. Trả lời tự nhiên, thành thật sẽ tạo ấn tượng tốt hơn nhiều.
              </p>
            </div>
          </div>
        )}

        {activeTab === 'tips' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Mẹo từ chuyên gia 15 năm kinh nghiệm</h2>
            
            <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border-2 border-yellow-300 rounded-xl p-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-16 h-16 flex items-center justify-center flex-shrink-0">
                  <i className="ri-medal-line text-5xl text-yellow-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Kinh nghiệm thực tế từ 3,000+ hồ sơ thành công</h3>
                  <p className="text-sm text-gray-700 mb-0">
                    Những mẹo dưới đây được tổng hợp từ hàng nghìn trường hợp thực tế mà tôi đã tư vấn. Áp dụng đúng sẽ giúp tăng đáng kể tỷ lệ thành công của bạn.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6 mb-8">
              {[
                {
                  title: 'Thời điểm nộp đơn tốt nhất',
                  icon: 'ri-calendar-line',
                  color: 'blue',
                  tips: [
                    'Nộp đơn ít nhất 3 tháng trước ngày dự kiến đi',
                    'Tránh mùa cao điểm (tháng 5-8) khi thời gian chờ lâu',
                    'Tháng 9-11 và tháng 1-3 thường có lịch phỏng vấn sớm hơn',
                    'Nếu bị từ chối, nên chờ ít nhất 3-6 tháng trước khi nộp lại'
                  ]
                },
                {
                  title: 'Cách tăng điểm hồ sơ',
                  icon: 'ri-file-chart-line',
                  color: 'green',
                  tips: [
                    'Có lịch sử xuất nhập cảnh các nước phát triển (Nhật, Hàn, Châu Âu, Úc)',
                    'Số dư tài khoản ổn định trong 6 tháng, không nạp đột ngột',
                    'Có công việc ổn định với hợp đồng lao động dài hạn',
                    'Đã kết hôn và có con nhỏ tại Việt Nam',
                    'Sở hữu bất động sản hoặc doanh nghiệp tại Việt Nam'
                  ]
                },
                {
                  title: 'Xử lý tình huống khó',
                  icon: 'ri-question-answer-line',
                  color: 'orange',
                  tips: [
                    'Nếu chưa đi nước ngoài: Nhấn mạnh công việc ổn định và ràng buộc gia đình',
                    'Nếu độc thân trẻ: Tập trung vào sự nghiệp và kế hoạch tương lai tại VN',
                    'Nếu thu nhập thấp: Có người bảo lãnh với giấy tờ đầy đủ',
                    'Nếu có người thân ở Mỹ: Chứng minh mục đích rõ ràng và ràng buộc mạnh tại VN'
                  ]
                },
                {
                  title: 'Những sai lầm phổ biến cần tránh',
                  icon: 'ri-error-warning-line',
                  color: 'red',
                  tips: [
                    'Nạp tiền đột ngột vào tài khoản trước khi phỏng vấn',
                    'Cung cấp thông tin không nhất quán giữa DS-160 và phỏng vấn',
                    'Không chuẩn bị câu trả lời cho câu hỏi "Tại sao quay về VN?"',
                    'Mang theo quá nhiều giấy tờ không cần thiết',
                    'Tỏ ra quá lo lắng hoặc thiếu tự tin'
                  ]
                },
                {
                  title: 'Tối ưu hóa DS-160',
                  icon: 'ri-file-edit-line',
                  color: 'purple',
                  tips: [
                    'Điền thông tin chính xác 100%, không được sai sót',
                    'Mô tả công việc chi tiết, chuyên nghiệp',
                    'Lịch trình du lịch cụ thể với địa điểm và thời gian rõ ràng',
                    'Kiểm tra kỹ trước khi submit, không thể sửa sau khi nộp',
                    'Lưu lại bản PDF để tham khảo khi phỏng vấn'
                  ]
                },
                {
                  title: 'Chuẩn bị tâm lý',
                  icon: 'ri-mental-health-line',
                  color: 'teal',
                  tips: [
                    'Luyện tập trả lời câu hỏi trước gương hoặc với bạn bè',
                    'Ngủ đủ giấc đêm trước ngày phỏng vấn',
                    'Đến sớm để làm quen với môi trường',
                    'Nhớ rằng lãnh sự viên không phải kẻ thù, họ chỉ làm công việc của mình',
                    'Nếu bị từ chối, đừng nản lòng - phân tích nguyên nhân và cải thiện'
                  ]
                }
              ].map((section, index) => (
                <div key={index} className={`bg-white border-2 border-${section.color}-200 rounded-xl p-6 hover:shadow-lg transition-shadow`}>
                  <div className="flex items-start gap-4 mb-4">
                    <div className={`w-12 h-12 flex items-center justify-center flex-shrink-0 bg-${section.color}-100 rounded-lg`}>
                      <i className={`${section.icon} text-3xl text-${section.color}-600`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 flex-1">{section.title}</h3>
                  </div>
                  <ul className="space-y-3 ml-16">
                    {section.tips.map((tip, idx) => (
                      <li key={idx} className="flex items-start gap-3 text-sm text-gray-700">
                        <i className={`ri-arrow-right-circle-fill text-${section.color}-600 text-lg mt-0.5 flex-shrink-0`}></i>
                        <span>{tip}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-teal-600 to-blue-700 rounded-xl p-8 text-white mb-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-plane-line text-5xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-3">Đã có Visa? Đặt Tour ngay hôm nay!</h3>
                <p className="text-base text-white/90 mb-6 max-w-2xl mx-auto">
                  Khám phá nước Mỹ với các tour du lịch được thiết kế chuyên nghiệp, phù hợp với mọi ngân sách. Từ Bờ Đông đến Bờ Tây, từ thành phố sôi động đến thiên nhiên hùng vĩ.
                </p>
                <div className="flex flex-wrap gap-4 justify-center">
                  <button className="bg-white text-teal-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                    Xem Tour Bờ Đông →
                  </button>
                  <button className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer">
                    Xem Tour Bờ Tây →
                  </button>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-yellow-900 mb-2">🏆 Lời khuyên cuối cùng</h4>
              <p className="text-sm text-gray-700 mb-0">
                Sau 15 năm trong nghề, tôi có thể khẳng định rằng <strong>không có công thức thần kỳ nào đảm bảo 100% được visa</strong>. Tuy nhiên, việc chuẩn bị kỹ càng, trung thực và tự tin sẽ giúp bạn có cơ hội cao nhất. Hãy nhớ rằng, nếu lần này không thành công, bạn vẫn có thể nộp lại sau khi cải thiện hồ sơ. Đừng bao giờ bỏ cuộc với ước mơ khám phá nước Mỹ!
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Bottom CTA */}
      <div className="mt-12 bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl p-8 text-white">
        <div className="flex items-center justify-between flex-wrap gap-6">
          <div className="flex-1 min-w-64">
            <h3 className="text-xl font-bold mb-2">Cần tư vấn thêm về Visa?</h3>
            <p className="text-sm text-gray-300">
              Liên hệ với chúng tôi để được tư vấn miễn phí và hỗ trợ chuẩn bị hồ sơ visa Mỹ
            </p>
          </div>
          <div className="flex gap-3">
            <button className="bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
              Tư vấn miễn phí
            </button>
            <button className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer">
              Xem Tour Mỹ
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}